import { useState } from 'react';
import { Tool } from '../context/AppContext';
import { etfUserLogin, isETFUserValid, isSCCUserValid, sccUserLogin } from '../api/userApi';


interface UserValidationResult {
  loading: boolean;
  error: string | null;
  isValideUser:  (email: string, tool: Tool) => Promise<boolean>;
  setError: (error: string | null) => void;
  login: (email: string, password: string, tool: Tool) => Promise<{message: string, data: any, token: string} | null>;
}

export function useUserValidation(): UserValidationResult {
  
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const isValideUser = async (email: string, tool: Tool) => {
    console.log("Checking user validity for email:", email, "with tool:", tool);
    if(tool !== Tool.ETF && tool !== Tool.SCC) {
      setError('Invalid tool specified');
      return false;
    }
    if (tool === Tool.SCC) {
      return await checkUserScc(email);
    }
    return await checkUserEtf(email);
  }

  const checkUserScc = async (email: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await isSCCUserValid(email);
      return res.data?.exists;
    } catch (e: any) {
      setError('User validation failed. Please check your email.');
      return false;
    } finally {
      setLoading(false);
    }
  }


  const checkUserEtf = async (email: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await isETFUserValid(email);            
      return res.data?.exists;
    } catch (e: any) {
      // setError('Failed to fetch users: ' + (e?.message || e));
      setError('User validation failed. Please check your email.');
      return false;
    } finally {
      setLoading(false);
    }
  }

  const loginToEtf = async (email: string, password: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await etfUserLogin(email, password);      
      return res.data;
    } catch (e: any) {
      setError('Login failed: ' + (e?.message || e));
      return null;
    } finally {
      setLoading(false);
    }
  }

  const loginToScc = async (email: string, password: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await sccUserLogin(email, password);      
      return res.data;
    } catch (e: any) {
      setError('Login failed: ' + (e?.message || e));
      return null;
    } finally {
      setLoading(false);
    }
  }

  const login = async (email: string, password: string, tool: Tool) => {
    if(tool !== Tool.ETF && tool !== Tool.SCC) {
      setError('Invalid tool specified');
      return null;
    }
    if (tool === Tool.SCC) {
      return await loginToScc(email, password);
    }
    return await loginToEtf(email, password);
  }
  




  return {  loading, error, isValideUser, setError, login };
}
